import styled from 'styled-components';
import Modal from 'components/common/Modal';
import palette from 'lib/styles/palette';
import useTempNotiListModal from 'hooks/service/useTempNotiListModal';
import Loading from 'components/common/Loading';
import { useState } from 'react';
import ErrorNoti from 'components/common/ErrorNoti';

const TempNotiCard = ({ noti }) => {
  return (
    <TempNotiCardBlock>
      <div>{`[${noti.store}]`}</div>
      <div>{noti.title}</div>
      <div style={{ textAlign: 'end' }}>{noti.createdAt}</div>
    </TempNotiCardBlock>
  );
};

const TempNotiCardBlock = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  width: 300px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.1);

  div + div {
    margin-top: 10px;
  }
`;

const TempNotiListModal = ({ onClose }) => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { data, hasNextPage, isFetchingNextPage, status, error, containerRef } =
    useTempNotiListModal();

  if (error?.response.status === 500) {
    onClose();
    setShowErrorModal(true);
  }

  return (
    <>
      {showErrorModal ? (
        <ErrorNoti
          style={{
            position: 'absolute',
            zIndex: 100,
            background: '#fff',
          }}
        />
      ) : (
        <Modal
          closeModal={onClose}
          header={{ text: '온도 알림', width: 430 }}
          style={{ height: 600 }}
        >
          <TempNotiListModalBlock>
            {error?.response.status === 401 || status === 'loading' ? (
              <Loading />
            ) : status === 'loading' ? (
              <div
                style={{ marginTop: 60, marginBottom: 40, fontWeight: 'bold' }}
              >
                알림 내역이 없습니다
              </div>
            ) : (
              status === 'success' &&
              data?.pages.map(page =>
                page?.result.map((noti, i) => (
                  <TempNotiCard key={i} noti={noti} />
                )),
              )
            )}
            {isFetchingNextPage ? (
              <Loading small />
            ) : hasNextPage ? (
              <div ref={containerRef} />
            ) : (
              <div />
            )}
            <button onClick={onClose}>닫기</button>
          </TempNotiListModalBlock>
        </Modal>
      )}
    </>
  );
};

export default TempNotiListModal;

const TempNotiListModalBlock = styled.div`
  padding: 0 2rem;
  padding-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 430px;

  button {
    margin: 1rem 0;
    padding: 0.5rem 2rem;
    border: none;
    color: white;
    border-radius: 10px;
    background: ${palette.theme[3]};
    cursor: pointer;
    &:hover {
      background: ${palette.theme[2]};
    }
  }
`;
